<div id="commentary" class="l-row commentary">
  <div class="l-full-width-col">
  <article *ngFor="let commentary of data" class="active" id="commentary-container-{{commentary.id}}">
    <div [ngClass]="{'accordion-header':true,'activeCommentary':commentary.id != route.snapshot.paramMap.get('id')}" (click)="goToNewRoute(commentary.id)">
      <span class="date">{{commentary.date | date : 'longDate'}}</span>
      <h1 [ngClass]="{'commentaryTitle':commentary.id != route.snapshot.paramMap.get('id') }">{{commentary.title}}</h1>
    </div>
    <section *ngIf="commentary.id == openCommentaryId" [innerHTML]="commentary.body"></section>
  </article>
  </div>
</div>
<div class="push"></div>




// WEBPACK FOOTER //
// ./src/app/commentary/display-commentary/display-commentary.component.html